import '../index.css';

function About() {
  return (
    <div className="About">
      <h1>About Page</h1>
    </div>
  );
}

export default About;
